var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    d: "M9.985 2.884c.516-.558.773-.838 1.047-1a2.148 2.148 0 0 1 2.146-.033c.278.155.544.426 1.075.969.531.542.797.814.948 1.098a2.277 2.277 0 0 1-.031 2.192c-.16.28-.433.543-.98 1.07l-6.503 6.263c-1.036.998-1.553 1.497-2.2 1.75-.648.252-1.36.234-2.783.197l-.193-.006c-.434-.01-.65-.017-.776-.16-.126-.142-.109-.363-.074-.804l.018-.24c.097-1.242.145-1.863.388-2.421.242-.559.66-1.012 1.498-1.919l6.42-6.956Zm-.742.08 4.84 4.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    d: "M9.934 15.412h5.533"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M0 0h16.597v16.597H0z",
    transform: "translate(.253 .197)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3eceac52.svg";
export { ForwardRef as ReactComponent };